








































import TabTips from './tab-tips.vue';
import { biHT } from '@/business/bi';
import { updateRedDot } from '@/business/red-dot';
import { getActiveInfo, HeaderTabText, HeaderTabType, isHeaderTabPage } from '@/config/page-tab';
import { i18n } from '@/i18n';
import { language } from '@tencent/ppd-base-libs';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component({
  components: {
    TabTips,
  },
})
export default class HeaderTab extends Vue {
  /** 当前激活的tab */
  private activeTab = HeaderTabType.couponlist;
  /** 当前激活的子tab */
  private activeSubTab = '';
  /** 是否展示tab */
  private isShow = false;
  /** tab访问记录 */
  private tabVisitedMap = {};
  @Prop() private redDotInfo;
  @Prop() private countInfo;

  private headerTabTextConfig = HeaderTabText;

  private get lang() {
    return language.getLang();
  }
  /** 当前激活的tab信息 */
  private get activeTabInfo() {
    return this.headerTabTextConfig.find(item => this.activeTab === item.key);
  }
  /** 是否有subtab */
  private get hasSubTab() {
    return this.activeTabInfo?.children?.length;
  }
  /** 获取tab名称 */
  public getSubtabText(subTab) {
    const name = subTab.text;
    const count = this.countInfo[subTab.key];
    if (typeof count === 'undefined') return name;
    const i18nParams = { count };
    const countText = i18n('{{count}}张', i18nParams);
    return `${name} ${countText}`;
  }

  public getSubTabAriaLabel(subTab) {
    return `${i18n('优惠券')} ${this.getSubtabText(subTab)}`;
  }

  /** 更新当前路由的红点 */
  public updateCurrentRouteRedDot() {
    this.updateHeaderRedDot(this.$route.name);
  }
  private created() {
  }

  @Watch('$route', { immediate: true })
  private handleRouteChange(to: Route, from: Route) {
	  this.isShow = isHeaderTabPage(to);
	  if (isHeaderTabPage(to)) {
      const activeInfo = getActiveInfo(to);
	    this.activeTab = activeInfo?.activeTab || '';
      this.activeSubTab = activeInfo?.activeSubTab || '';
      this.updateHeaderRedDot(from.name);
      this.updateHeaderRedDot(to.name);
	  }
  }

  @Watch('isShow')
  private handleIsShow() {
    if (this.isShow) {
      this.markTabVisited(this.activeTab);
      biHT('promozone.myasset.myassets_brow');
    }
  }

  private updateHeaderRedDot(key) {
    // Header需要更新小红点 + 发请求
    if (this.redDotInfo[key]) {
      // 如果没有小红点，则不需发请求update
      updateRedDot(key);
    }
    this.$emit('clearRedDot', { tab: 'header', key });
  }

  private biTag(key) {
    switch (key) {
      case (HeaderTabType.couponlist):
        biHT('promozone.myasset.couponbtn_click');
        break;
      case (HeaderTabType.stamplist):
        biHT('promozone.myasset.stampcardbtn_click');
        break;
      case (HeaderTabType.displaycouponlist):
        biHT('promozone.myasset.merchantcouponbtn_click');
        break;
      case (HeaderTabType.voucherlist):
        biHT('promozone.myasset.cvbtn_click');
        break;
      default:
        return;
    }
  }

  private onClickTab(key) {
    this.biTag(key);
    this.markTabVisited(key);
    if (key !== this.activeTab) {
      this.$router.replace({ name: key });
    }
  }
  private onClickSubTab(key) {
    biHT('promozone.myasset.subtab_click', {
      ftoptabid: this.activeTab,
      fsubtabid: key,
    });
    if (key !== this.activeSubTab) {
      this.$router.replace({ name: key });
    }
  }
  /**
   * 是否展示tab的红点
   * 如果用户访问过这个tab，本次会话内就不会展示这个tab的小红点
   * 如果这个tab的subtab的红点没有了，就不会展示这个tab的小红点
   */
  private isShowTabRedDot(tabKey) {
    const tabInfo = this.headerTabTextConfig.find(item => item.key === tabKey);
    const isVisited = this.isTabVisited(tabKey);
    // 对于没有subtab的tab，直接取这个tab(路由)的红点记录
    if (!tabInfo?.children?.length) return !isVisited && this.redDotInfo[tabKey];
    // 对于有subtab的tab，判断subtab中是否还有红点
    return !isVisited && tabInfo.children.some(item => this.isShowSubTabRedDot(item.key));
  }
  /**
   * 是否展示subtab的红点
   */
  private isShowSubTabRedDot(subTabKey) {
    return this.activeSubTab !== subTabKey && this.redDotInfo[subTabKey];
  }
  /**
   * 标记是否访问过此tab
   */
  private markTabVisited(tabKey) {
    const isTab = this.headerTabTextConfig.map(item => item.key).includes(tabKey);
    if (isTab) {
      this.tabVisitedMap[tabKey] = true;
    }
  }
  /**
   * 判断是否访问过此tab
   */
  private isTabVisited(tabKey) {
    return this.tabVisitedMap[tabKey];
  }

  /**
   * 主动管理聚焦元素
   */
  private ariaAutoFocus() {
    setTimeout(() => {
      if (this.activeSubTab === 'displaycouponlist') {
        document.getElementById('subtab-item-1')?.focus();
      } else {
        document.getElementById('subtab-item-0')?.focus();
      }
    }, 500);
  }

  private mounted() {
    this.ariaAutoFocus();
  }
}
